module.exports = __webpack_public_path__ + "static/media/cross.cad70081.svg";